import {useUpmPlantsContext} from '@hconnect/upm'
import {usePermissionsQuery} from '@hproduce/permissions'
import {Navigate, Outlet} from 'react-router'

import {RefraPlannerLayout, DefaultLoadingComponent} from '../../common/components'
import {useUrlParam} from '../hooks'
import {ROUTES} from '../routes'

export const RefraPlannerPlantPage: React.FC = () => {
  const plantCode = useUrlParam('plantCode')

  const upmPlants = useUpmPlantsContext({isInitialLoad: true})
  const {data: requiredPermissions} = usePermissionsQuery()

  if (!requiredPermissions || !upmPlants) {
    return <DefaultLoadingComponent />
  }

  // Checking that provided plantCode is valid
  if (upmPlants[plantCode] === undefined) {
    return <Navigate to={ROUTES.NOT_FOUND.path} replace />
  }

  // Checking if user has permissions to view Refra Planner
  if (requiredPermissions.length === 0) {
    return <Navigate to={ROUTES.NOT_AUTHORIZED.path} replace />
  }

  return (
    <RefraPlannerLayout>
      <Outlet />
    </RefraPlannerLayout>
  )
}
